"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForNext = void 0;
const operators_1 = require("rxjs/operators");
function waitForNext(criteria) {
    return observable => {
        return observable.pipe((0, operators_1.filter)(value => valueMeetsCriteria(value, criteria)), (0, operators_1.take)(1));
    };
}
exports.waitForNext = waitForNext;
function valueMeetsCriteria(value, criteria) {
    if (!criteria)
        return !!value;
    else
        return criteria(value);
}
//# sourceMappingURL=wait-for-next.js.map